import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import MDBox from "components/MDBox";
import { useMaterialUIController, setLayout } from "context";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [dispatch, pathname]);

  return (
    <MDBox
      sx={{
        minHeight: "100vh",
        marginLeft: {
          xs: 0,
          xl: miniSidenav ? "112px" : "308px",
        },
        px: { xs: 1.25, sm: 2, md: 3.5 },
        py: { xs: 1.5, md: 3.5 },
        transition: "margin-left 220ms ease",
        background:
          "radial-gradient(circle at top left, rgba(76,195,138,0.08) 0%, rgba(9,17,30,0) 28%), radial-gradient(circle at top right, rgba(94,168,255,0.1) 0%, rgba(9,17,30,0) 32%)",
      }}
    >
      {children}
    </MDBox>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
